// ponytail: per-country limits; unknown dial codes fall back to 7–15
const DEFAULT_PHONE_MIN = 7;
const DEFAULT_PHONE_MAX = 15;

function c(name, dialCode, code, flag, phoneMinLength = DEFAULT_PHONE_MIN, phoneMaxLength = DEFAULT_PHONE_MAX) {
  return { name, dialCode, code, flag, phoneMinLength, phoneMaxLength };
}

export const countries = [
  c("United States", "+1", "US", "🇺🇸", 10, 10),
  c("United Kingdom", "+44", "GB", "🇬🇧", 10, 11),
  c("Canada", "+1", "CA", "🇨🇦", 10, 10),
  c("Australia", "+61", "AU", "🇦🇺", 9, 9),
  c("India", "+91", "IN", "🇮🇳", 10, 10),
  c("Germany", "+49", "DE", "🇩🇪", 10, 11),
  c("France", "+33", "FR", "🇫🇷", 9, 9),
  c("Italy", "+39", "IT", "🇮🇹", 9, 10),
  c("Spain", "+34", "ES", "🇪🇸", 9, 9),
  c("Netherlands", "+31", "NL", "🇳🇱", 9, 9),
  c("Belgium", "+32", "BE", "🇧🇪", 9, 9),
  c("Switzerland", "+41", "CH", "🇨🇭", 9, 9),
  c("Austria", "+43", "AT", "🇦🇹", 10, 13),
  c("Sweden", "+46", "SE", "🇸🇪", 9, 10),
  c("Norway", "+47", "NO", "🇳🇴", 8, 8),
  c("Denmark", "+45", "DK", "🇩🇰", 8, 8),
  c("Finland", "+358", "FI", "🇫🇮", 9, 10),
  c("Poland", "+48", "PL", "🇵🇱", 9, 9),
  c("Russia", "+7", "RU", "🇷🇺", 10, 10),
  c("China", "+86", "CN", "🇨🇳", 11, 11),
  c("Japan", "+81", "JP", "🇯🇵", 10, 10),
  c("South Korea", "+82", "KR", "🇰🇷", 9, 10),
  c("Singapore", "+65", "SG", "🇸🇬", 8, 8),
  c("Hong Kong", "+852", "HK", "🇭🇰", 8, 8),
  c("Malaysia", "+60", "MY", "🇲🇾", 9, 10),
  c("Indonesia", "+62", "ID", "🇮🇩", 9, 11),
  c("Thailand", "+66", "TH", "🇹🇭", 9, 9),
  c("Vietnam", "+84", "VN", "🇻🇳", 9, 10),
  c("Philippines", "+63", "PH", "🇵🇭", 10, 10),
  c("New Zealand", "+64", "NZ", "🇳🇿", 9, 10),
  c("South Africa", "+27", "ZA", "🇿🇦", 9, 9),
  c("Brazil", "+55", "BR", "🇧🇷", 10, 11),
  c("Argentina", "+54", "AR", "🇦🇷", 10, 10),
  c("Mexico", "+52", "MX", "🇲🇽", 10, 10),
  c("Chile", "+56", "CL", "🇨🇱", 9, 9),
  c("Colombia", "+57", "CO", "🇨🇴", 10, 10),
  c("Peru", "+51", "PE", "🇵🇪", 9, 9),
  c("Venezuela", "+58", "VE", "🇻🇪", 10, 10),
  c("United Arab Emirates", "+971", "AE", "🇦🇪", 9, 9),
  c("Saudi Arabia", "+966", "SA", "🇸🇦", 9, 9),
  c("Turkey", "+90", "TR", "🇹🇷", 10, 10),
  c("Israel", "+972", "IL", "🇮🇱", 9, 9),
  c("Egypt", "+20", "EG", "🇪🇬", 10, 10),
  c("Pakistan", "+92", "PK", "🇵🇰", 10, 10),
  c("Bangladesh", "+880", "BD", "🇧🇩", 10, 10),
  c("Sri Lanka", "+94", "LK", "🇱🇰", 9, 9),
  c("Nepal", "+977", "NP", "🇳🇵", 10, 10),
  c("Ireland", "+353", "IE", "🇮🇪", 9, 9),
  c("Portugal", "+351", "PT", "🇵🇹", 9, 9),
  c("Greece", "+30", "GR", "🇬🇷", 10, 10),
];

export const DEFAULT_DIAL = "+91";

export function getCountryByDialCode(dialCode) {
  return countries.find((x) => x.dialCode === dialCode);
}

export function getPhoneLimits(dialCode) {
  const country = getCountryByDialCode(dialCode);
  return {
    min: country?.phoneMinLength ?? DEFAULT_PHONE_MIN,
    max: country?.phoneMaxLength ?? DEFAULT_PHONE_MAX,
  };
}

export function filterCountries(query) {
  const q = query.trim().toLowerCase();
  if (!q) return countries;
  return countries.filter(
    (x) =>
      x.name.toLowerCase().includes(q) ||
      x.dialCode.includes(q) ||
      x.code.toLowerCase().includes(q)
  );
}

export function parsePhone(phoneStr, defaultDial = DEFAULT_DIAL) {
  if (!phoneStr) return { dial: defaultDial, raw: "" };
  const match = phoneStr.match(/^(\+\d+)\s*(.*)$/);
  if (match) return { dial: match[1], raw: match[2].replace(/\D/g, "") };
  return { dial: defaultDial, raw: phoneStr.replace(/\D/g, "") };
}

export function formatPhone(dial, raw) {
  const digits = String(raw || "").replace(/\D/g, "");
  if (!digits) return "";
  return `${dial} ${digits}`;
}

export function stripPhoneDigits(value, maxLen) {
  return String(value || "").replace(/\D/g, "").slice(0, maxLen);
}
